<script lang="ts">
  import RingConfigSheet from "./RingConfigSheet.svelte";
  import ScoresDrawer from "./ScoresDrawer.svelte";
  import ShareSheet from "./ShareSheet.svelte";
  import SetDetailSheet from "./SetDetailSheet.svelte";
  import SetsDiscoveredSheet from "./SetsDiscoveredSheet.svelte";
  import SetPageSheet from "./SetPageSheet.svelte";
  import SwimCalendarSheet from "./SwimCalendarSheet.svelte";
  import Fastest25sSheet from "./Fastest25sSheet.svelte";
  import SuspectDeck from "../lib/SuspectDeck.svelte";
  import { activeOverlay, medianWeekKm } from "../lib/overlay";
  import { currentDerivedWorkout } from "../lib/state";

  // Single top-layer mount point for the overlays. Sits OUTSIDE the inerted
  // #app-shell so the open sheet stays interactive while the page, nav, and FAB
  // underneath are inert. `activeOverlay` is a single slot, so at most one of
  // these is ever `open`. SetDetailSheet's dw comes from the selected-swim
  // store (currentDerivedWorkout, published by Prototypes), so the sheet
  // always resolves setGroups[setIndex] against the swim the ribbon shows.
</script>

<RingConfigSheet
  open={$activeOverlay?.kind === "ring"}
  ring={$activeOverlay?.kind === "ring" ? $activeOverlay.ring : "week-distance"}
  medianWeekKm={$medianWeekKm}
/>
<ShareSheet open={$activeOverlay?.kind === "share"} />
<ScoresDrawer open={$activeOverlay?.kind === "scores"} />
<SetsDiscoveredSheet open={$activeOverlay?.kind === "sets-discovered"} />
<SetPageSheet
  open={$activeOverlay?.kind === "set-history"}
  setId={$activeOverlay?.kind === "set-history" ? $activeOverlay.setId : ""}
  from={$activeOverlay?.kind === "set-history" ? $activeOverlay.from : undefined}
/>
{#if $currentDerivedWorkout}
  <SetDetailSheet
    open={$activeOverlay?.kind === "set-detail"}
    dw={$currentDerivedWorkout}
    setIndex={$activeOverlay?.kind === "set-detail" ? $activeOverlay.setIndex : 0}
    fixFirst={$activeOverlay?.kind === "set-detail" ? ($activeOverlay.fixFirst ?? false) : false}
    fixLapIndex={$activeOverlay?.kind === "set-detail" ? $activeOverlay.fixLapIndex : undefined}
  />
{/if}
<SwimCalendarSheet
  open={$activeOverlay?.kind === "your-swims"}
  club={$activeOverlay?.kind === "your-swims" ? ($activeOverlay.club ?? null) : null}
/>
<Fastest25sSheet
  open={$activeOverlay?.kind === "fastest-25s"}
  stroke={$activeOverlay?.kind === "fastest-25s" ? $activeOverlay.stroke : ""}
/>
<SuspectDeck />
